import React, { useState } from 'react';
import Icon from "@scentregroup/ui/components/icon";
import { jsx as _jsx } from "react/jsx-runtime";

const MenuToggle = ({
  doShowClear,
  isOpen,
  openMenu,
  closeMenu,
  clearInput,
  style
}) => {
  // Hack to make Safari work (see commit message):
  const {
    0: doesClearHavePointer,
    1: setDoesClearHavePointer
  } = useState(false);

  if (doShowClear || doesClearHavePointer) {
    return /*#__PURE__*/_jsx("button", {
      type: "button",
      className: style['menu-toggle'],
      onPointerDown: () => setDoesClearHavePointer(true),
      onClick: () => {
        clearInput();
        setDoesClearHavePointer(false);
      },
      children: /*#__PURE__*/_jsx(Icon, {
        type: "clear",
        size: "small"
      })
    });
  } else if (isOpen) {
    return /*#__PURE__*/_jsx("button", {
      type: "button",
      className: style['menu-toggle'],
      onClick: closeMenu,
      children: /*#__PURE__*/_jsx(Icon, {
        type: "chevron-up",
        size: "small"
      })
    });
  } else {
    return /*#__PURE__*/_jsx("button", {
      type: "button",
      className: style['menu-toggle'],
      onClick: openMenu,
      children: /*#__PURE__*/_jsx(Icon, {
        type: "chevron-down",
        size: "small"
      })
    });
  }
};

export default MenuToggle;